import store from '../store'
const authGuard = (to, from, next) => {
  if(to.query.user_id){
    console.log(to.query.user_id)
    store.commit('system/setUserId',to.query.user_id);
  }
  // 路由发生变化修改页面title
  if (to.meta.title) {
    document.title = to.meta.title;
    store.commit('system/setTitle',to.meta.title);
  }
  // 把需要缓存的路由放到数组中
  if (
    to.name &&
    to.meta.keepAlive &&
    !store.state.system.router.includes(to.name)
  ) {
    store.commit('system/updateRouter', {
      type: 'add',
      data: to.name
    })
  }
  if(to.name==='login'||to.name==='register'){
    if(store.state.user.userInfo.token){
      next('/user');
    }
  }
  if (to.meta.auth) {
    let username = store.state.user.token;

    if (!username) {//未登录情况拦截用户中心路由
      console.log("https://gzh.xjddjyz.cn/api/oauth?user_id="+store.state.system.user_id+"&redirect="+to.fullPath);
      location.href = "https://gzh.xjddjyz.cn/api/oauth?user_id="+store.state.system.user_id+"&redirect="+to.fullPath;//http://xjddf.conjure.net.cn/
      store.commit('system/setUserId',0);
      // next('/login');
    } else {
      next();
    }
  } else {
    next()
  }
}

export default authGuard



// WEBPACK FOOTER //
// ./src/service/auth-guard.js